import React, {useRef} from 'react'
import Modal from "./index";
import XIcon from "@heroicons/react/outline/XIcon";
import DialogDefaultFooter from './modal-footer'
import {classNames} from "../../common/util/util-helpers";
import LoaderSmall from "../loader-small";

export default function ModalDefault({
                                         show,
                                         initialFocusRef,
                                         widthClass,
                                         hideOverlay,
                                         onClose,
                                         onBackdropClick,
                                         isLoading,
                                         onButtonClick,
                                         buttonDisabled,
                                         buttonLabel,
                                         onSecondaryButtonClick,
                                         secondaryButtonLabel,
                                         title,
                                         customButtonsHTML,
                                         secondaryButtonDisabled,
                                         closeButtonLabel,
                                         options,
                                         hideXbtn,
                                         children,
                                         addCustomButtonsClass,
                                         limitHeight
                                     }) {
    const closeButtonRef = useRef(null);

    return (
        <Modal
            show={show}
            hideOverlay={hideOverlay}
            onClose={onClose}
            widthClass={widthClass}
            onBackdropClick={onBackdropClick}
            initialFocusRef={initialFocusRef ?? closeButtonRef}
        >
            <div className="relative bg-inverse">
                <header
                    className="p-4 flex items-center border-secondary border-b text-tm-gray-900">
                    <h2 className="text-lg text-current truncate">{title}</h2>

                    {!hideXbtn && (
                        <button className="absolute right-5 top-5 focus:ring-2 focus:ring-offset-2 focus:ring-offset-inverse focus:ring-primary rounded-full"
                                aria-label="Close"
                                onClick={() => {
                                    onClose();
                                }}>
                            <XIcon className="w-5 h-5"/>
                        </button>
                    )}

                    {!!options && (
                        <div className="ml-auto pr-14">
                            {options}
                        </div>
                    )}
                </header>

                <div className={classNames(limitHeight ? "h-dialog-body" : "", isLoading ? "invisible" : "")}>
                    {children}
                </div>

                {isLoading && (
                    <div className="inset-center">
                        <LoaderSmall/>
                    </div>
                )}

                <DialogDefaultFooter
                    buttonLabel={buttonLabel}
                    buttonDisabled={buttonDisabled}
                    onButtonClick={onButtonClick}

                    closeButtonLabel={closeButtonLabel}
                    onClose={onClose}

                    secondaryButtonLabel={secondaryButtonLabel}
                    secondaryButtonDisabled={secondaryButtonDisabled}
                    onSecondaryButtonClick={onSecondaryButtonClick}

                    addCustomButtonsClass={addCustomButtonsClass}
                >
                    {!!customButtonsHTML && (
                        customButtonsHTML
                    )}
                </DialogDefaultFooter>
            </div>
        </Modal>
    )
}
